/**
 * Remembers where the user was when they left for GitHub's app-install flow,
 * so /github/setup can send them back there (e.g. a project page) instead of
 * always landing on the dashboard. sessionStorage: survives the redirect
 * round-trip, dies with the tab.
 */
const KEY = 'github-setup-return';

export function rememberGithubReturnPath(path?: string) {
  try {
    sessionStorage.setItem(KEY, path ?? window.location.pathname + window.location.search);
  } catch { /* private mode etc. — fall back to default landing */ }
}

export function consumeGithubReturnPath(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    // Only allow in-app paths — never absolute URLs.
    return v && v.startsWith('/') ? v : null;
  } catch {
    return null;
  }
}
